import { Fragment } from "react"
import classNames from "classnames"
import { Switch } from "@headlessui/react"

export default function ToggleWithLabelAndDescription({
  label,
  description,
  checked,
  disabled,
  onChange,
}) {
  return (
    <div
      className={classNames("flex items-center justify-between", {
        "opacity-25": disabled,
      })}
    >
      <Switch.Group>
        {!!label && (
          <span className="flex flex-grow flex-col">
            <Switch.Label>
              <span
                className="mr-4 text-sm font-medium text-neutral-2"
                id="availability-label"
              >
                {label}
              </span>
            </Switch.Label>
            {!!description && (
              <span
                className="text-sm text-neutral-6"
                id="availability-description"
              >
                {description}
              </span>
            )}
          </span>
        )}
        <Switch checked={checked} onChange={onChange} as={Fragment}>
          {({ checked }) => (
            <button
              role="switch"
              disabled={disabled}
              aria-checked="false"
              aria-labelledby="availability-label"
              aria-describedby="availability-description"
              className={classNames(
                "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-5 focus:ring-offset-2",
                {
                  "bg-primary-5": checked,
                  "bg-neutral-8": !checked,
                  "cursor-not-allowed": disabled,
                }
              )}
            >
              <span className="sr-only">{label}</span>
              <span
                aria-hidden="true"
                className={classNames(
                  "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out",
                  { "translate-x-5": checked, "translate-x-0": !checked }
                )}
              />
            </button>
          )}
        </Switch>
      </Switch.Group>
    </div>
  )
}
